import { stats } from '@/mocks/content';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-8 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div>
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-500">About Vigorbuy</span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mt-4 leading-tight">
              Why Use Vigorbuy<br />Spreadsheet?
            </h2>
            <div className="mt-8 space-y-5">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                The <strong>Vigorbuy Spreadsheet</strong> helps buyers organize products, compare categories, discover popular items, and make better purchasing decisions. Built as a comprehensive resource for smart shoppers, it brings together the best finds across sneakers, hoodies, bags, jackets, and accessories into one easy-to-navigate system.
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                Whether you are looking for the latest sneaker drops, premium hoodies, designer bags, trending jackets, or everyday accessories, our <strong>vigorbuy sheet</strong> guides simplify the entire buying process. Each entry is verified, categorized, and updated to reflect current availability and pricing.
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                Our curated <strong>vigorbuy spreadsheet</strong> resources eliminate guesswork. Instead of browsing countless pages, you get a structured overview with direct links, QC checklists, sizing references, and safety tips — all in one place. We believe smart shopping should be effortless and accessible to everyone.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((stat, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-xl p-6 md:p-8 text-center border border-background-200/60"
              >
                <span className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-primary-500 block">
                  {stat.value}
                </span>
                <span className="text-sm text-foreground-500 mt-2 block">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}